module.exports = __webpack_public_path__ + "media/images/frontend/less-a1d0de68f38f28d512b4709f771fda0b.svg";